<template>
	<div class="h_wk">
		<h1 class="h1">和平精英在线估值</h1>
		<div style="margin-top:20px;text-align: center;color: #fff;">
			<span class="btn-item" @click="ptLogin('wx')">VX登入</span>
			<span class="btn-item" @click="ptLogin('qq')">扣扣登入</span>
		</div>
		<div style="margin-top:20px auto;text-align: center;color: #fff;display: flex;align-items: center;justify-content: center;" v-show="!loading&&roleList.length>0">
			<span class="btn-item" @click="createImg()">{{showCreateLoading?'生成中':'生成图片'}}</span>
			<span class="btn-item"><colorPicker v-model="color"></colorPicker></span>
		</div>
		<div class="loading-show" v-show="loading">请稍后...</div>
		<div class="h_main" v-show="!loading&&roleList.length>0" ref="capture" :style="allColor()">
			<div style="margin: 50px;">
				<div class="h_main_s clearfix" v-show="showShuiyin">
					<div class="h_main_s_logo fl">
						<img src="../images/logo.png">
					</div>
					<div class="h_main_s_yx fl">
						<img src="../images/h_yx.png">
					</div>
					<div class="h_main_s_bbq fl" v-if="qq.qq_hpjy"><span>{{qq.qq_hpjy}}</span></div>
					<div class="h_main_s_yx fl">
						<img src="../images/h_yx.png">
					</div>
				</div>
				<div v-for="item in roleList" :key="item.roleId" >
					<div class="h_main_m">
						<span class="span">{{item.roleName}} </span>
						<span class="span" v-for="text in item.roleText" :key="text">{{text}}</span>
					</div>
					<div class="h_main_m">
						<span v-for="tab in item.depotdetail.tabs" :key="(item.roleId+'_'+tab.tabId)">
							<span class="span" v-if="tab.count>0">{{tab.tabName}}-{{tab.count}}</span>
						</span>
						
					</div>
					<div class="h_main_m">
						<span class="span" v-if="item.yanse6>0">粉装-{{item.yanse6}}</span>
						<span class="span" v-if="item.taozhuang>0">套装-{{item.taozhuang}}</span>
					</div>
					<div class="h_main_x" :style="backgroundStyle">
						<div class="h_main_xk clearfix" >
							<div class="h_main_xknr clearfix" >
								<draggable v-model="item.depotdetail.list" style="z-index: 1;">
									<transition-group name="flip-list" style="display: flex;flex-wrap:wrap;">
										<div class="h_main_xk_li" v-for="pi in item.depotdetail.list" :key="pi.itemId">
											<div class="h_main_xk_li_t">
												<img :src="pi.imageUrl">
											</div>
											<p :style="nameStyle(pi.quality)">{{pi.itemName}}</p>
										</div>
									</transition-group>
									
								</draggable>
								
								
							</div>
							
						</div>
						<div class="h_main_zs"><img src="../images/md.png"></div>
						<div class="h_main_yzs"><img src="../images/md.png"></div>
					</div>
				</div>
				
			</div>
		</div>
		
		
	</div>
</template>

<script>
import { qqLogin,wxLogin,HpjyRoleList} from "../server";
import html2canvas from "html2canvas";
import draggable from "vuedraggable";
import { getStorageSync } from "../unitl/common";
import { constant } from "../unitl/constant";
import {hpjyData} from "../unitl/test.js"
// function drawBase64Image(img) {
// 	var canvas = document.createElement("canvas");
// 	canvas.width = 100;
// 	canvas.height = 100;
// 	var ctx = canvas.getContext("2d");
// 	ctx.drawImage(img, 0, 0, img.width, img.height);
// 	var dataURL = canvas.toDataURL("image/png");
// 	return dataURL;
// }
var browser = {
    versions: (function() {
        var u = navigator.userAgent;
        return {
            //移动终端浏览器版本信息
            trident: u.indexOf("Trident") > -1, //IE内核
            presto: u.indexOf("Presto") > -1, //opera内核
            webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或者uc浏览器
            iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("iPad") > -1, //是否iPad
            webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
            weixin: u.indexOf("MicroMessenger") > -1, //是否微信
            qq: u.match(/\sQQ/i) == " qq" //是否QQ
        };
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
};
export default {
    name: "Hpjy",
    data() {
        return {
            token:'',
			userId:"",
			openid:"",
			gameid:'20004',
			roleList:[],
			loading:false,
			showloading:false,
			showCreateLoading:false,
			showShuiyin:true,
			bg:'',
			qq:{},
			color:'',
			testImg:''
        };
    },
	computed:{
		backgroundStyle(){
			var backgroundImg='';
			var backgroundRepeat='';
			var bg=require('../assets/bg4.png');
			
			if(this.showShuiyin){
				backgroundImg=`url(${bg})`;
				backgroundRepeat='repeat-y';
			}

			let style={
				backgroundImage:backgroundImg,
				backgroundRepeat:backgroundRepeat,
				backgroundSize:'100%',
				backgroundColor:this.color
			}
			return style;
		}
	},
	
    components: {
        draggable
    },
    watch: {
        pageIndex(val) {
            this.loadBackgounds(val);
        }
    },
    methods: {
		allColor(){
			if(this.color){
				return {color:this.color};
			}
			return {};
		},
		nameStyle(quality){
			if(quality==6){
				//粉色
				return {
					color:'pink'
				}
			}
			if(quality==5){
				//紫色
				return {
					color:'#5b3663'
				}
			}
			if(quality==4){
				//蓝色
				return {
					color:'#36527d'
				}
			}
		},
		createImg() {
			if(this.showCreateLoading)return;
			this.showloading = true;
			this.showCreateLoading = true;
			
			let rect = this.$refs.capture.getBoundingClientRect();
			const rate = 4000 / rect.height;
			var scale=1;
			if (
				rate < 1 &&
				(browser.versions.mobile ||
					browser.versions.ios ||
					browser.versions.android ||
					browser.versions.iPhone ||
					browser.versions.iPad)
			) {
				this.$refs.capture.style.transform = `scale(${rate})`;
				rect = this.$refs.capture.getBoundingClientRect();
			}else{
				if(rate<1){
					scale=Math.max((1-parseInt(rect.height/4000)*0.1),0.5);
					
				}
			}
			console.log(scale);
			
		
	
			const scrollTop =
				document.documentElement.scrollTop || document.body.scrollTop;
			html2canvas(this.$refs.capture, {
				scale:scale,
				imageTimeout: 10000000,
				useCORS: true,
				x: Math.round(rect.x+(browser.versions.mobile?0:this.htmlCanvasAdjustX)),
				y: Math.round(rect.y),
				scrollY: -scrollTop,
				width: Math.round(rect.width-(browser.versions.mobile?0:this.htmlCanvasAdjustWidth)),
				height: Math.round(rect.height)
			}).then(canvas => {
				// 通过a标签下载到本地
				let link = document.createElement("a");
				link.href = canvas.toDataURL("image/jpeg");
				link.setAttribute("download", '和平精英_'+Date.now() + ".jpg");
				link.style.display = "none";
				document.body.appendChild(link);
				link.click();
				this.showCreate = true;
				this.showCreateLoading = false;
				this.showloading = false;
				this.$refs.capture.style.transform = `scale(1)`;
			});
	
		},
		ptLogin(pt){
			location.href="http://p.laodas.com/ptlogin#&a=a#&md=hpjy&pt="+pt
		},
		wxLogin(params){
			wxLogin({
				code:params.code
			}).then(res=>{
				// console.log(res);
				this.loginSuccess(res,res.data.appOpenid);
			})
		},
		initRoleList(roleList){
			for(var i in roleList){
				roleList[i].yanse6=0;
				roleList[i].yanse5=0;
				roleList[i].yanse4=0;
				roleList[i].taozhuang=0;
				for(var j in roleList[i].depotdetail.list){
					if(roleList[i].depotdetail.list[j].quality==6){
						roleList[i].yanse6+=1;
					}
					if(roleList[i].depotdetail.list[j].itemName.indexOf('套装')==-1){
						roleList[i].taozhuang+=1;
					}
				}
				roleList[i].depotdetail.list.sort(function(x,y){
					if(x.quality>y.quality){
						return -1;
					}else if(x.quality==y.quality){
						return 0;
					}else{
						return 1;
					}
				})
			}
			this.roleList=roleList;
		},
		getRoleList(){
			var userInfo=JSON.parse(getStorageSync(constant.userInfo)||'{}');
			if(userInfo&&userInfo.shuiyin){
				this.showShuiyin=false;
			}
			
			HpjyRoleList({
				token:this.token,
				userId:this.userId,
				openId:this.openid
			}).then(res=>{
				this.loading=false;
				var roleList=res.data[this.gameid];
				this.initRoleList(roleList);
				
				//quality =6 粉色 =5紫色  =4蓝色
				// console.log(JSON.stringify(this.roleList));
			})
		},
		loginSuccess(res,openid){
			this.userId=res.data.userId;
			this.token=res.data.token;
			this.openid=openid;
			this.qq=res.qq;
			
			console.log('userId',this.userId);
			console.log('token',this.token);
			console.log('openid',this.openid);
			console.log('qq',res.qq);
			
			
			this.getRoleList();
			
		},
		qqLogin(params){
			this.openid=params.openid;
			
			qqLogin({
				appOpenid:params.openid,
				openId:params.openid,
				payToken:params.pay_token,
				accessToken:params.access_token
			}).then(res=>{
				this.loginSuccess(res,this.openid);
			})
		},
		getParameter(){
			var obj = new Object();
			var str = window.location.href.split('?')[1];
			if(!str) return obj;
			var arrList = str.split('&');
			if(arrList.length>0){
				for(var i=0;i<arrList.length;i++){
					var arr = arrList[i].split('=')
					obj[arr[0]] = window.decodeURIComponent(arr[1])
				}
				
			}
			return obj;
		}
    },

    mounted() {
		var test=true;
		if(!test){
			var params=this.getParameter();
			if(params&&params.openid&&params.loginType=='qq'){
				this.loading=true;
				this.qqLogin(params);
			}
			if(params&&params.code&&params.loginType=='wx'){
				this.loading=true;
				this.wxLogin(params);
			}
		}else{
			this.token='26Yh8Ysa';
			this.userId='720424413';
			this.openid='o7KEU0gKDK3gY5qJM8BtSqKYjxUo';
			// this.getRoleList();
	
			
			this.initRoleList(hpjyData.data.data[20004])
		}
    }
};
</script>

<style scoped>
	.btn-item .m-colorPicker::before {
		content: "选择背景颜色";
		padding-right: 7px;
		color: #fff;
	}

h1 {
    margin-top: 80px;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    line-height: 28px;
}
.tips {
    padding-left: 20px;
    margin: 19px auto 0;
    width: 70px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(65, 194, 131, 1);
    line-height: 28px;
    background: url("../assets/green.png") left center no-repeat;
}
.h1{
	margin-top: 40px;
}
.loading-show{
    margin-top: 30px;
    color: #ffffff;
	font-size: 20px;
}


.btn-item {
    color: #fff;
    border-radius: 4px;
	padding:5px 10px;
    width: 130px;
    text-align: center;
    background: rgba(44, 82, 129, 1);
    margin: 10px;
    cursor: pointer;
}

@charset "utf-8";

/* CSS Document */
* {
	font-family: "微软雅黑";
	outline: none;
	font-size: 14px;
	color: #444444;
	list-style: none;
	line-height: 26px;
}

* {
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	-webkit-tap-highlight: rgba(0, 0, 0, 0);
	-webkit-text-size-adjust: none;
}

body, dl, dd, h1, h2, h3, h4, h5, h6, from {
	margin: 0;
}

img {
	max-width: 100%;
	display: block;
}

ol, ul, li, img {
	margin: 0;
	padding: 0;
	border: 0;
	outline: 0;
	vertical-align: baseline;
}

input, img, textarea {
	border: none;
	border-radius: 0;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	-webkit-tap-highlight: rgba(0, 0, 0, 0);
	-webkit-text-size-adjust: none;
}

a {
	text-decoration: none;
	blr: expression(this.onFocus=this.blur()); /* IE Opera */
	outline: none; /* FF Opera */
}

a:focus {
	-moz-outline-style: none; /* FF */
}

img, input {
	border: 0;
}

input, textarea, select {
	outline: none;
}

a div, a span {
	cursor: pointer;
}

textarea {
	resize: none;
}

/*闃叉textarea鏀惧ぇ鏃讹紝涓変釜鏂滅嚎琚斁澶?*/
*, *:before, *:after {
	box-sizing: border-box;
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	-o-box-sizing: border-box;
}

html, body, ul, li, a, span, p {
	padding: 0;
	margin: 0;
	list-style: none;
	line-height: 22px;
	margin: 0px;
	padding: 0px
}

img {
	border: 0px;
}

.juzhong {
	width: 1250px;
	display: block;
	margin-left: auto;
	margin-right: auto;
}

.lfd {
	float: left;
	display: block;
}

.rfd {
	float: right;
	display: block;
}

h2, h3, h4, h5 {
	text-align: center;
}

p {
	font-family: "微软雅黑";
	line-height: 26px;
}

.gg {
	width: 1200px;
	margin-left: auto;
	margin-right: auto;
}

.clear {
	clear: both;
}

.clearfix:after {
	visibility: hidden;
	display: block;
	font-size: 0;
	content: " ";
	clear: both;
	height: 0;
}

.clearfix {
	*zoom: 1;
}

.fl {
	float: left;
}

.fr {
	float: right;
}

/* 和平精英样式开始 */
.h_wk {
	width: 100%;
	background: url('../images/hbg.jpg');
	background-repeat: no-repeat;
	background-position: center top;
	background-attachment: fixed;
	min-height: 1080px;
}

.h_main {
	width: 1400px;
	margin: 0px auto;
	overflow: hidden;
	background-color: #000;
	
}

.h_main_s_bbq {
	border: 1px solid #f6be02;
	text-align: center;
	padding: 2px 20px;
	transform: skew(-30deg);
	margin-top: 30px;
}

.h_main_s_bbq span {
	color: #fff;
	font-size: 24px;
	line-height: 24px;
}

.h_main_s_zx {
	margin-top: 28px;
	margin-left: 55px;
	margin-right: 20px;
}

.h_main_s_yx {
	margin-top: 28px;
	margin-left: 50px;
}

.h_main_s_hp {
	margin-top: 12px;
}

.h_main_m{
	margin: 40px 0;
	text-align: left;
}
.h_main_m .span{
	font-size: 40px;
	font-weight: bold;
	color: #fff;
	margin-right: 20px;
}

.h_main_x {
	border: 14px solid;
	border-image-source: url("../images/ew.jpg");
	border-image-slice: 40%;
	border-image-repeat: round;
	border-radius: 16px;
	position: relative;
}

.h_main_xk {
	background: url('../images/h_nkbg.png');
	background-repeat: repeat;
	padding: 0;
}

.h_main_xk_li {
	width: 12.5%;
	margin-bottom: 30px;
	padding: 10px;
}

.h_main_xk_li:nth-child(7n) {
	margin-right: 0px;
}

.h_main_xk_li_t {
	width: 100%;
}

.h_main_xk_li_t img {
	width: 100%;
	object-fit: cover;
	padding: 10px;
	border-radius: 10px;
}

.h_main_xk_li p {
	text-align: center;
	font-size: 20px;
	color: #fff;
	font-weight: bold;
	margin-top: 10px;
}

.h_main_zs {
	position: absolute;
	left: -14px;
	top: -15px;
}

.h_main_yzs {
	position: absolute;
	right: -14px;
	top: -15px;
}




</style>
